<div class="snackbar {{show}}">{{message}}</div>
<section class="cart">
    <div class="container">
        <table class="table">
            <tr>
                <th>Article Name</th>
                <th>Category</th>
                <th>Date of Order</th>
                <th>No. of Days</th>
                <th>Rent</th>
                <th></th>
            </tr>
            <tr style="border-bottom:1px solid black">
                <td colspan="90%"><hr style="width:98%;"></td>
              </tr>
            <tr *ngFor="let dress of clothes; index as i">
                <td>{{dress.dress_name}}</td>
                <td *ngIf="dress.category == 1">Bridal</td>
                <td *ngIf="dress.category == 2">Casual</td>
                <td *ngIf="dress.category == 3">Suits</td>
                <td *ngIf="dress.category == 4">Groom</td>
                <td>{{today | date: 'shortDate'}}</td>
                <td>{{dress.orderedDays}}</td>
                <td>{{dress.basic_rent}}</td>
            </tr>
        </table>
        <div class="order-details">
            <div class="radios">
                <div class="delivery-method">
                    <h3>Delivery Method</h3>
                    <mat-radio-group aria-label="Select an option" [(ngModel)]="delivery" name="delivery" color ='primary'>
                        <mat-radio-button value="1">Home Delivery</mat-radio-button>
                        <br>
                    </mat-radio-group>
                </div>
                <div class="payment-method">
                    <h3>Payment Method</h3>
                    <mat-radio-group aria-label="Select an option" [(ngModel)]="payment" name="Payment" color ='primary'>
                        <mat-radio-button value="1">Cash On Delivery</mat-radio-button>
                        <br>
                    </mat-radio-group>
                </div>
            </div>
           <div class="add-total">
                <div class="address">
                    <h3>Address</h3>
                    <textarea class="signup-text-area" [(ngModel)]="address"  name="message" rows="10" cols="30" placeholder="Enter Complete Street Address " required></textarea>
                </div>
                <div class="total-payment">
                    <h2>Rent: {{totalRent}}</h2>
                    <h2>Security: {{security}}</h2>
                    <h2>Delivery charges:100</h2>
                    <h1>Total: {{totalRent+security+100}}</h1>
                </div>
            </div>
            <div class="confirm-order">
                <input type="checkbox" [(ngModel)]="agree" name="checkbox" required><label class="term">The information above is true and I agree to the <a href="#">terms and conditions.</a></label>
                <button class="sign" type="submit" (click)="confirm()" *ngIf='!processing'>Confirm Order</button>
                <button class="sign" type="submit" (click)="confirm()" disabled *ngIf='processing'>Confirm Order</button>
            </div>
        </div>
    </div>
</section>